/**
 * 【KYMW1407】画像情報管理更新
 *
 * @export UpdateImageInfoModel
 * @class UpdateImageInfoModel
 */
export class UpdateImageInfoModel {
  // 画像ID
  public imageId = String('');
  // 使用開始受注コード
  public startOrderCode = String('');
  // 使用終了受注コード
  public endOrderCode = String('');
  // 加工指示
  public processInstruct = String('');
  // 備考
  public remarks = String('');
  // 料理例掲載区分
  public cookingExPublish = String('');
  // 優先度
  public priority = String('');
  // 料理分類
  public cookingDiv = String('');
  // 料理名
  public cookingName = String('');
  // 材料名
  public materialName = String('');
  // キーワード
  public keyWord = String('');
  // 催事・季節
  public eventId = String('');
  // 撮影内容区分
  public photoContentsDiv = String('');
  // 撮影指示内容
  public photoInstructContents = String('');
  // 撮影予定日
  public photoSchedule = String('');
  // 撮影場所ID
  public photoStudioId = String('');
  // 画像キャプション
  public textCaption = String('');
}
